import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowRightBlue = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.5 12.5C4.5 11.9477 4.94772 11.5 5.5 11.5H19.5C20.0523 11.5 20.5 11.9477 20.5 12.5C20.5 13.0523 20.0523 13.5 19.5 13.5H5.5C4.94772 13.5 4.5 13.0523 4.5 12.5Z",
		fill: "#076698"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.7929 4.79289C12.1834 4.40237 12.8166 4.40237 13.2071 4.79289L20.2071 11.7929C20.5976 12.1834 20.5976 12.8166 20.2071 13.2071L13.2071 20.2071C12.8166 20.5976 12.1834 20.5976 11.7929 20.2071C11.4024 19.8166 11.4024 19.1834 11.7929 18.7929L18.0858 12.5L11.7929 6.20711C11.4024 5.81658 11.4024 5.18342 11.7929 4.79289Z",
		fill: "#076698"
	})]
});
export { SvgArrowRightBlue as ReactComponent };
